export default __webpack_public_path__ + "static/media/PrivacyPolicy-EN.c09771ed.pdf";